<div class="alert alert-dismissible custom-alert-error mr-1" [style.width.%]="width">
    <button type="button" (click)="closeModel()" class="close close-modified" data-dismiss="alert">
        &times;
    </button>
    <div class="Notification">
        <div class="error-icon"><img src="assets/images/warning.png" /></div>
        <div class="login-error-message">{{ errorMessage }}</div>
    </div>
</div>
